import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Tellimuse tarneaeg

  <span style="color:#85c1dc;">**FI:**</span>
  Tilauksen toimitusaika

  <span style="color:#85c1dc;">**RU:**</span>
  Срок доставки заказа
*/
/* @__NO_SIDE_EFFECTS__ */
const m655 = msg(
  mf`Tellimuse tarneaeg`,
  mf`Tilauksen toimitusaika`,
  mf`Срок доставки заказа`,
)

export { m655 as 'w.module.delivery_section.delivery_time.home' }